import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { Tablev2Component } from '../tablev2/tablev2.component';

@Component({
  selector: 'app-setting-player-level',
  templateUrl: './setting-player-level.component.html',
  styleUrls: ['./setting-player-level.component.scss']
})
export class SettingPlayerLevelComponent implements AfterViewInit {

  public company_uuid;
  @ViewChild("table", { static: false }) tb: Tablev2Component;

  constructor(private http: HttpService, private cdr : ChangeDetectorRef) {
    this.http.getSelectedCompany().subscribe(val => {
      this.company_uuid = val;
    });
   }

   ngAfterViewInit(): void {
    this.init();
  }

  async init() {
    const setting = 
        { post: {url: "/admin/setting/player-level/get", data: {}},
          disabled_pagenat: true,
          fields: [
            {label: 'No', type: 'index'}, 
            {label: 'Title', type: 'string', key: 'title'}, 
            {label: 'Promotion Audience', type: 'string', key: 'promotion_audience'},
            {label: 'Upgrade By', type: 'string', key: 'upgrade_player_level'},
            {label: 'Min', type: 'number', key: 'min_deposit'},
	            {label: 'Max', type: 'number', key: 'max_deposit'},
	            {label: 'Rolling L1', type: 'number', key: 'rolling_l1_rate'},
	            {label: 'Rolling L2', type: 'number', key: 'rolling_l2_rate'},
	            {label: 'Rolling L3', type: 'number', key: 'rolling_l3_rate'},
	            {label: 'Auto Conversion', type: 'status', key: 'auto_conversion'},
            {label: 'Sort', type: 'number', key: 'sort'}, 
            {label: 'Status', type: 'status', key: 'status'}, 
            {label: 'View', type: 'link', key: 'uuid', 'link': '/lo/' + this.company_uuid + "/setting-player-level/form", hide: true},
            {label: 'Delete', type: 'delete', key: 'uuid', table: 'setting_player_level', title: 'title', hide: true},
          ]}
      this.tb.init(setting);
      this.cdr.detectChanges();
  }

}
